<template>
    <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive">
            <el-table border stripe :data="data" class="el-table-css" style="width: 100%">
                <!-- Issued status icon -->
                <el-table-column width="54" align="center">
                    <template #default="scope">
                        <div class="d-flex align-items-center justify-content-center">
                            <i v-if="scope.row.medicalPolicy.issued" class="bi bi-patch-check-fill text-success fs-6" title="Buraxılıb"></i>
                            <i v-else class="bi bi-dash text-muted opacity-50"></i>
                        </div>
                    </template>
                </el-table-column>

                <!-- Signing Status -->
                <el-table-column prop="medicalPolicy.signStatus" label="İmzalanma statusu" width="160">
                    <template #default="scope">
                        <span class="sign-status-pill" :class="getSignStatusClass(scope.row.medicalPolicy.signStatus)">
                            <i class="bi bi-pen me-1"></i>{{ scope.row.medicalPolicy.signStatus }}
                        </span>
                    </template>
                </el-table-column>

                <!-- Policy Number & Status -->
                <el-table-column label="SŞ nömrəsi" width="280">
                    <template #default="scope">
                        <div class="d-flex align-items-center justify-content-between gap-2">
                            <a class="doc-number-link" @click="GoToPolicy(scope.row.medicalPolicy.policyId)">
                                <i class="bi bi-shield-check me-1"></i>{{ scope.row.medicalPolicy.policyFullNumber }}
                            </a>
                            <span class="status-badge-pill" :class="getStatusBadgeClass(scope.row.medicalPolicy.policyStatusName)">
                                {{ scope.row.medicalPolicy.policyStatusName }}
                            </span>
                        </div>
                    </template>
                </el-table-column>

                <!-- Policy Date -->
                <el-table-column prop="medicalPolicy.policyDateStr" label="Tarix" width="115" align="center">
                    <template #default="scope">
                        <span class="task-time-chip font-monospace">{{ scope.row.medicalPolicy.policyDateStr }}</span>
                    </template>
                </el-table-column>

                <!-- Insured Company / Person -->
                <el-table-column prop="medicalPolicy.insured.name" label="Sığortalı" min-width="170">
                    <template #default="scope">
                        <span class="fw-bold text-dark-emphasis">
                            <i class="bi bi-building me-1 text-muted"></i>{{ scope.row.medicalPolicy.insured?.name }}
                        </span>
                    </template>
                </el-table-column>

                <!-- Insured Person -->
                <el-table-column prop="medicalPolicy.insuredPerson.name" label="Sığorta olunan" min-width="170">
                    <template #default="scope">
                        <span>
                            <i class="bi bi-person me-1 text-muted"></i>{{ scope.row.medicalPolicy.insuredPerson?.name || '—' }}
                        </span>
                    </template>
                </el-table-column>

                <!-- Pay Type -->
                <el-table-column prop="medicalPolicy.payType" label="Ödənilmə qaydası" width="140" align="center">
                    <template #default="scope">
                        <span class="meta-chip meta-chip--blue">{{ scope.row.medicalPolicy.payType }}</span>
                    </template>
                </el-table-column>

                <!-- Currency -->
                <el-table-column prop="medicalPolicy.currency" label="Valyuta" width="90" align="center">
                    <template #default="scope">
                        <span class="meta-chip meta-chip--gray">{{ scope.row.medicalPolicy.currency }}</span>
                    </template>
                </el-table-column>

                <!-- Start Date -->
                <el-table-column prop="medicalPolicy.startDateStr" label="Başlanma tarixi" width="125" align="center">
                    <template #default="scope">
                        <span class="font-monospace text-muted">{{ scope.row.medicalPolicy.startDateStr }}</span>
                    </template>
                </el-table-column>

                <!-- End Date -->
                <el-table-column prop="medicalPolicy.endDateStr" label="Bitmə tarixi" width="125" align="center">
                    <template #default="scope">
                        <span class="font-monospace text-muted">{{ scope.row.medicalPolicy.endDateStr }}</span>
                    </template>
                </el-table-column>

                <!-- Cancel Date -->
                <el-table-column prop="medicalPolicy.cancelDateStr" label="Dayandırma tarixi" width="135" align="center">
                    <template #default="scope">
                        <span class="font-monospace text-danger" v-if="scope.row.medicalPolicy.cancelDateStr">{{ scope.row.medicalPolicy.cancelDateStr }}</span>
                        <span class="text-muted opacity-50" v-else>—</span>
                    </template>
                </el-table-column>

                <!-- Cancel Type -->
                <el-table-column prop="medicalPolicy.cancelTypeName" label="Dayandırma növü" width="180">
                    <template #default="scope">
                        <span>{{ scope.row.medicalPolicy.cancelTypeName || '—' }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: Array,
        showFilter: Boolean
    },
    methods: {
        GoToPolicy(value) {
            window.open(window.location.origin + '/documents/policy/' + value, "_blank");
        },
        getStatusBadgeClass(statusName) {
            if (!statusName) return "badge--in-progress";
            if (statusName.includes("Aktiv") || statusName.includes("Qüvvədə")) return "badge--approved";
            if (statusName.includes("Dayandırılıb") || statusName.includes("Ləğv") || statusName.includes("düşmüş")) return "badge--rejected";
            return "badge--in-progress";
        },
        getSignStatusClass(signStatus) {
            if (!signStatus) return "sign--pending";
            if (signStatus.includes("İmzalanıb")) return "sign--completed";
            return "sign--pending";
        }
    }
};
</script>

<style scoped lang="scss">
.task-time-chip {
    font-size: 0.8rem;
    font-weight: 650;
    padding: 2px 6px;
    border-radius: 4px;
    background: var(--app-surface-soft, #f8fafc);
    border: 1px solid var(--app-border, #e2e8f0);
}

.sign-status-pill {
    display: inline-flex;
    align-items: center;
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 0.74rem;
    font-weight: 650;
    line-height: 1.2;

    &.sign--completed {
        background: rgba(16, 185, 129, 0.12);
        color: #059669;
        border: 1px solid rgba(16, 185, 129, 0.3);
    }
    &.sign--pending {
        background: rgba(245, 158, 11, 0.12);
        color: #d97706;
        border: 1px solid rgba(245, 158, 11, 0.3);
    }
}

.status-badge-pill {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 9999px;
    font-size: 0.72rem;
    font-weight: 700;
    white-space: nowrap;

    &.badge--approved {
        background: rgba(16, 185, 129, 0.12);
        color: #059669;
        border: 1px solid rgba(16, 185, 129, 0.35);
    }
    &.badge--in-progress {
        background: rgba(59, 130, 246, 0.12);
        color: #2563eb;
        border: 1px solid rgba(59, 130, 246, 0.35);
    }
    &.badge--rejected {
        background: rgba(239, 68, 68, 0.12);
        color: #dc2626;
        border: 1px solid rgba(239, 68, 68, 0.35);
    }
}

.meta-chip {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 9999px;
    font-size: 0.74rem;
    font-weight: 650;

    &--blue {
        background: rgba(11, 79, 156, 0.1);
        color: var(--bs-info, #0b4f9c);
    }
    &--green {
        background: rgba(16, 185, 129, 0.12);
        color: #059669;
    }
    &--gray {
        background: rgba(100, 116, 139, 0.12);
        color: #475569;
    }
}

[data-theme="dark"] {
    .task-time-chip {
        background: #141b22;
        border-color: #283544;
        color: #e2e8f0;
    }

    .sign-status-pill {
        &.sign--completed {
            background: rgba(16, 185, 129, 0.2);
            color: #34d399;
            border-color: rgba(52, 211, 153, 0.35);
        }
        &.sign--pending {
            background: rgba(245, 158, 11, 0.2);
            color: #fbbf24;
            border-color: rgba(251, 191, 36, 0.35);
        }
    }

    .meta-chip--gray {
        background: rgba(255, 255, 255, 0.1);
        color: #cbd5e1;
    }

    .status-badge-pill {
        &.badge--approved {
            background: rgba(16, 185, 129, 0.2);
            color: #34d399;
            border-color: rgba(52, 211, 153, 0.35);
        }
        &.badge--in-progress {
            background: rgba(59, 130, 246, 0.2);
            color: #93c5fd;
            border-color: rgba(96, 165, 250, 0.35);
        }
        &.badge--rejected {
            background: rgba(239, 68, 68, 0.2);
            color: #fca5a5;
            border-color: rgba(248, 113, 113, 0.35);
        }
    }
}
</style>